import { useTranslation } from 'react-i18next';

export type FooterMenuLinkItem = { type: 'link'; label: string; to?: string; href?: string };

const useFooterMenuLinks = () => {
  const { t } = useTranslation();

  const defaultFooterMenuLinks: FooterMenuLinkItem[] = [
    {
      type: 'link',
      label: t('menuLabels.testFormats'),
      to: 'test-format'
    },
    {
      type: 'link',
      label: t('menuLabels.forInstitutions'),
      to: 'for-institutions'
    },
    {
      type: 'link',
      label: t('menuLabels.helpCenter'),
      to: 'help-center'
    }
  ];

  return defaultFooterMenuLinks;
};

export default useFooterMenuLinks;
